import CCPANotice from './ccpa_notice';
export default CCPANotice;
